import { create } from 'zustand';
import type { CandidateStore } from './candidate.store.types';
import { default as Candidate } from 'model/Candidate';
import { queryClient } from 'config/queryClient';
import { QueryKey } from 'types/query';
import { InfiniteData } from '@tanstack/react-query';
import { PaginatedResponse } from 'clients/types';
import { Conversation } from 'components/ui/organisms/CentralInbox/CentralInbox.types';

export const useCandidateStore = create<CandidateStore>((set) => ({
  selectedCandidate: null,
  setSelectedCandidate: (campaignId, rawCandidate) =>
    set(() => {
      return { selectedCandidate: new Candidate(campaignId, rawCandidate) };
    }),
  setCandidateLabels(labels) {
    set((state) => {
      if (!state.selectedCandidate) return {};

      const candidate = state.selectedCandidate;
      const campaignId = candidate.campaignId;

      const updatedCandidate = new Candidate(campaignId, {
        ...candidate.raw,
        reasons: labels,
      });

      queryClient.setQueryData<InfiniteData<PaginatedResponse<Conversation>>>(
        [QueryKey.getInfiniteConversations],
        (data) => {
          if (!data) return data;
          return {
            pageParams: data.pageParams,
            pages: data.pages.map((page: PaginatedResponse<Conversation>) => {
              return {
                ...page,
                results: page.results.map((conversation: Conversation) => {
                  if (!conversation.candidate) return conversation;
                  return conversation.esPersonId === candidate.es_person_id
                    ? { ...conversation, candidate: { ...conversation.candidate, reasons: labels } }
                    : conversation;
                }),
              };
            }),
          };
        },
      );

      return {
        selectedCandidate: updatedCandidate,
      };
    });
  },
}));
